import { useRef } from "react";
import { LuUpload } from "react-icons/lu";
import { components } from "../../../design/tokens";
import {
  DashboardMode,
  useDashboardControlsActions,
  useDashboardMode,
  WorkspaceSection,
} from "../../../view_stores/useDashboardControlsStore";
import {
  PreviewMode,
  useProjectPreviewMode,
} from "../../../view_stores/useProjectPreviewStore";
import { ProjectPreviewScreenshotControls } from "../../projectPreview/components/ProjectPreviewScreenshotControls";
import { ProjectDashboardModeSwitch } from "./ProjectDashboardModeSwitch";
import { ProjectAppNameEditor } from "./ProjectAppNameEditor";

export default function ProjectDashboardTopPanel({
  isDisabled,
  panelWidth,
}: {
  isDisabled: boolean;
  panelWidth?: number;
}) {
  const dashboardMode = useDashboardMode();
  const previewMode = useProjectPreviewMode();

  const { setDashboardMode, setWorkspaceSection } =
    useDashboardControlsActions();

  const containerRef = useRef<HTMLDivElement>(null);

  function onPublishClick() {
    setDashboardMode(DashboardMode.WORKSPACE);
    setWorkspaceSection(WorkspaceSection.PUBLISH);
  }

  return (
    <div
      ref={containerRef}
      className="flex items-center relative border-b border-dark-border"
    >
      {/* Left Section - Matches left panel width */}
      <div
        className="flex items-center gap-3 px-4 py-1"
        style={{ width: panelWidth ? `${panelWidth}px` : 'calc(30% * var(--container-width, 100vw))' }}
      >
        {/* App Title */}
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <ProjectAppNameEditor />
        </div>
      </div>

      {/* Invisible Divider (1px to match SplitPanel) */}
      <div className="w-px h-full bg-dark-border opacity-0" />

      {/* Right Section - Takes remaining space */}
      <div className="flex-1 flex items-center gap-4 px-4 py-1">
        {/* Mode Switch */}
        <div className="flex items-center gap-2">
          <ProjectDashboardModeSwitch isDisabled={isDisabled} />
          {dashboardMode === DashboardMode.PREVIEW &&
            previewMode === PreviewMode.Desktop && (
              <ProjectPreviewScreenshotControls optionsPosition="bottom-center" />
            )}
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Action Buttons */}
        <div className="flex items-center gap-4">
          <button
            onClick={onPublishClick}
            disabled={isDisabled}
            className={components.button.primary}
          >
            <LuUpload size={16} />
            <span>Publish</span>
          </button>
        </div>
      </div>
    </div>
  );
}
